import { DomainModel } from 'domains/models';
import { isPhone } from 'infras/validator';

export default class BusinessProfile extends DomainModel {
  teamId: number;
  name: string;
  owner: string;
  address: string;
  tel: string;
  priceDescription: string;
  paymentMethodDescription: string;
  paymentScheduleDescription: string;
  feeDescription: string;
  serviceDescription: string;
  refundDescription: string;
  environmentDescription: string;

  constructor(props: any) {
    super(props);
    this._className = 'BusinessProfile';
    this.teamId = props.teamId;
    this.name = props.name;
    this.owner = props.owner;
    this.address = props.address;
    this.tel = props.tel;
    this.priceDescription = props.priceDescription;
    this.paymentMethodDescription = props.paymentMethodDescription;
    this.paymentScheduleDescription = props.paymentScheduleDescription;
    this.feeDescription = props.feeDescription;
    this.serviceDescription = props.serviceDescription;
    this.refundDescription = props.refundDescription;
    this.environmentDescription = props.environmentDescription;
  }

  isValid(scopes: string[] | null = null) {
    super.beforeValidate();
    let p = '';

    p = 'tel';
    if (!scopes || scopes.includes(p)) {
      if (!this.tel) {
        this.addError(p, 'E001');
      }
      if (!isPhone(this.tel) && this.tel.length > 250) {
        this.addError(p, 'E002');
      }
    }
    p = 'owner';
    if (!scopes || scopes.includes(p)) {
      if (!this.owner) {
        this.addError(p, 'E001');
      }
      if (this.owner.length > 250) {
        this.addError(p, 'E002');
      }
    }
    p = 'name';
    if (!scopes || scopes.includes(p)) {
      if (!this.name) {
        this.addError(p, 'E001');
      }
      if (this.name.length > 250) {
        this.addError(p, 'E002');
      }
    }
    p = 'address';
    if (!scopes || scopes.includes(p)) {
      if (!this.address) {
        this.addError(p, 'E001');
      }
      if (this.address.length > 2000) {
        this.addError(p, 'E002');
      }
    }
    p = 'priceDescription';
    if (!scopes || scopes.includes(p)) {
      if (!this.priceDescription) {
        this.addError(p, 'E001');
      }
      if (this.priceDescription.length > 2000) {
        this.addError(p, 'E002');
      }
    }
    p = 'paymentMethodDescription';
    if (!scopes || scopes.includes(p)) {
      if (!this.paymentMethodDescription) {
        this.addError(p, 'E001');
      }
      if (this.paymentMethodDescription.length > 2000) {
        this.addError(p, 'E002');
      }
    }
    p = 'paymentScheduleDescription';
    if (!scopes || scopes.includes(p)) {
      if (!this.paymentScheduleDescription) {
        this.addError(p, 'E001');
      }
      if (this.paymentScheduleDescription.length > 2000) {
        this.addError(p, 'E002');
      }
    }
    p = 'feeDescription';
    if (!scopes || scopes.includes(p)) {
      if (!this.feeDescription) {
        this.addError(p, 'E001');
      }
      if (this.feeDescription.length > 2000) {
        this.addError(p, 'E002');
      }
    }
    p = 'serviceDescription';
    if (!scopes || scopes.includes(p)) {
      if (!this.serviceDescription) {
        this.addError(p, 'E001');
      }
      if (this.serviceDescription.length > 2000) {
        this.addError(p, 'E002');
      }
    }
    p = 'refundDescription';
    if (!scopes || scopes.includes(p)) {
      if (!this.refundDescription) {
        this.addError(p, 'E001');
      }
      if (this.refundDescription.length > 2000) {
        this.addError(p, 'E002');
      }
    }
    p = 'environmentDescription';
    if (!scopes || scopes.includes(p)) {
      if (!this.environmentDescription) {
        this.addError(p, 'E001');
      }
      if (this.environmentDescription.length > 2000) {
        this.addError(p, 'E002');
      }
    }

    return super.isValid();
  }

  static permited = [
    'name',
    'owner',
    'address',
    'tel',
    'priceDescription',
    'paymentMethodDescription',
    'paymentScheduleDescription',
    'feeDescription',
    'serviceDescription',
    'refundDescription',
    'environmentDescription',
  ];

  static permit(updater: any) {
    return super.permit(updater, this.permited);
  }
}
